import {useTranslations} from 'next-intl';
import Container from '@/container';
import {Grid, Row, Col} from '@/grid';
import {withBgNeutral200} from '@/hocs/withColors';
import styles from './styles.module.scss';

const Neutral200Div = withBgNeutral200('div');

const TrustedByStrip = () => {
  const t = useTranslations('homepage');

  return (
    <Neutral200Div className={styles.strip}>
      <Container>
        <Grid fluid>
          <Row>
            <Col xs={12}>
              <p className={styles.text}>{t('trustedBy')}</p>
            </Col>
          </Row>
        </Grid>
      </Container>
    </Neutral200Div>
  );
};

export default TrustedByStrip;
